<script>
    import sysData from "../../Stores/systemStore.js";

    export let item;
    export let showName = true;
    let iconUrl;

    $: iconUrl = iconUrlForItem(item);

    function iconUrlForItem(item) {
    if (item != undefined && item.icon_name != undefined) {
        var iconData = $sysData.icons[item.icon_name];
        return "data:image/png;base64," + iconData;
    }
}

</script>

<div id="name-col">
    <div>
        <img
            id="name-image"
            src={iconUrl}
            alt="Item logo"
        />
    </div>
    {#if showName == true}
        <div>
            {item.name ?? ""}
        </div>
    {/if}
</div>

<style>
    #name-col {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
    }
    #name-image {
        width: 32px;
        height: 32px;
        margin: auto 2px;
        vertical-align: center;
    }
</style>
